<div class="gd-scrolling-list tw-flex">

  <gd-scroller #scroller
    [scrollConfig]="{ scrollX: true, scrollY: false}">
    <div class="gd-scrolling-list-wrapper tw-flex tw-justify-center tw-items-center tw-gap-2 tw-h-[130px]">

      @for (tile of collection; track tile) {
        <div #collectionItems
          class="gd-scrolling-list__item"
          [attr.id]="tile.id"
          [class.active]="tile.active"
          [style.background-image]="'url(' + tile.thumbnail + ')'"
          (click)="previewGalleryImage(tile)">
          <img class="gd-scrolling-list__item-img"
            [src]="tile.thumbnail"
            alt="">
            <div class="gd-scrolling-list-wrapper__indicator"> </div>
          </div>
        }

      </div>
    </gd-scroller>

  </div>
